import { 
    useState, 
    useEffect, 
} from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { withPather } from 'react-pather';
import { DomainsTable } from './common';
import Loader from '../../../Loader';

const rowsPerPage = 30;

const Trends = ({ pather }) => {

    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    // Pagination
    const [offset, setOffset] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const fetchTrends = () => {
        setLoading(true);
        axios.get(pather.back.Settings.trends, 
            { 
                params: { 
                    perPage: rowsPerPage,
                    offset,
                } 
            }
        )
        .then(response => {
            const data = response.data;
            console.log(data);
            setRows(data?.rows);
            setTotalPages(data?.total_pages);
        })
        .catch(error => {
            console.log(error);
            const status = error?.response?.data?.status;
            status && enqueueSnackbar(status, { variant: 'error' });
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchTrends();
    }, [offset]);

    const handleOffsetChange = (event, value) => setOffset(value - 1);

    return (
        <>
            {
                loading ? 
                <Loader/> :
                <DomainsTable 
                    rows={rows} 
                    totalPages={totalPages} 
                    offset={offset} 
                    handleOffsetChange={handleOffsetChange}
                />
            }
        </>
    )
}

export default withPather()(Trends);